import { render, staticRenderFns } from "./SubsourceRulesModal.vue?vue&type=template&id=7901aaa2&lang=pug&"
import script from "./SubsourceRulesModal.vue?vue&type=script&lang=js&"
export * from "./SubsourceRulesModal.vue?vue&type=script&lang=js&"
import style0 from "./SubsourceRulesModal.vue?vue&type=style&index=0&id=7901aaa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports